var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-10" }, [
    _c(
      "div",
      { staticClass: "bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" },
      [
        _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
          _c("div", { staticClass: "md:col-span-1" }, [
            _c(
              "h3",
              { staticClass: "text-lg font-medium leading-6 text-gray-900" },
              [_vm._v(" Configuration ")]
            ),
            _c("p", { staticClass: "mt-1 text-sm leading-5 text-gray-500" }, [
              _vm._v(" Configure whatsapp by adding your number ")
            ]),
            _c(
              "div",
              [_c("WhatsappButton", { attrs: { config: _vm.config } })],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "mt-5 md:mt-0 md:col-span-2" },
            [
              _vm.showAlert
                ? _c("Alert", { attrs: { text: _vm.alertText } })
                : _vm._e(),
              _c("form", { on: { submit: _vm.handleSubmit } }, [
                _c("div", { staticClass: "grid grid-cols-3 gap-6" }, [
                  _c("div", { staticClass: "col-span-3 sm:col-span-2" }, [
                    _c("div", [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block text-sm font-medium leading-5 text-gray-700",
                          attrs: { for: "phone_number" }
                        },
                        [_vm._v("Phone Number ")]
                      ),
                      _c(
                        "div",
                        { staticClass: "mt-1 relative rounded-md shadow-sm" },
                        [
                          _c("vue-tel-input", {
                            attrs: {
                              value: _vm.phoneNumber,
                              mode: "international"
                            },
                            on: { input: _vm.handlePhoneNumberUpdate }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _c("fieldset", { staticClass: "mt-6" }, [
                  _c(
                    "legend",
                    {
                      staticClass:
                        "text-base leading-6 font-medium text-gray-900"
                    },
                    [_vm._v(" Position ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "mt-4 flex flex-wrap" },
                    _vm._l(_vm.supportedPosition, function(position, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "flex items-center m-2" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.config.position,
                                expression: "config.position"
                              }
                            ],
                            staticClass:
                              "form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out",
                            attrs: {
                              id: "radio_" + position.value,
                              type: "radio"
                            },
                            domProps: {
                              value: position.value,
                              checked: _vm._q(
                                _vm.config.position,
                                position.value
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.config,
                                  "position",
                                  position.value
                                )
                              }
                            }
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "ml-3",
                              attrs: { for: "radio_" + position.value }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "block text-sm leading-5 font-medium text-gray-700"
                                },
                                [_vm._v(_vm._s(position.label) + " ")]
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _c("fieldset", { staticClass: "mt-6" }, [
                  _c(
                    "legend",
                    {
                      staticClass:
                        "text-base leading-6 font-medium text-gray-900"
                    },
                    [_vm._v(" Design ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "mt-4 flex flex-wrap" },
                    _vm._l(_vm.supportedDesign, function(design, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "flex items-center m-2" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.config.design,
                                expression: "config.design"
                              }
                            ],
                            staticClass:
                              "form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out",
                            attrs: {
                              id: "radio_design_" + design.value,
                              type: "radio"
                            },
                            domProps: {
                              value: design.value,
                              checked: _vm._q(_vm.config.design, design.value)
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.config,
                                  "design",
                                  design.value
                                )
                              }
                            }
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "ml-3",
                              attrs: { for: "radio_design_" + design.value }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "block text-sm leading-5 font-medium text-gray-700"
                                },
                                [_vm._v(_vm._s(design.label) + " ")]
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _c("div", { staticClass: "mt-6" }, [
                  _c("div", { staticClass: "rounded-md" }, [
                    _c("div", { staticClass: "grid grid-cols-6 gap-6" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block text-sm font-medium leading-5 text-gray-700",
                              attrs: { for: "city" }
                            },
                            [_vm._v("Button Background")]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.config.colors.buttonBackgroundColor,
                                expression:
                                  "config.colors.buttonBackgroundColor"
                              }
                            ],
                            staticClass:
                              "mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                            domProps: {
                              value: _vm.config.colors.buttonBackgroundColor
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.config.colors,
                                  "buttonBackgroundColor",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _c("verte", {
                            staticClass: "colorPicker",
                            attrs: { picker: "square", model: "hex" },
                            model: {
                              value: _vm.config.colors.buttonBackgroundColor,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.config.colors,
                                  "buttonBackgroundColor",
                                  $$v
                                )
                              },
                              expression: "config.colors.buttonBackgroundColor"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block text-sm font-medium leading-5 text-gray-700",
                              attrs: { for: "city" }
                            },
                            [_vm._v("Button Text Color")]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.config.colors.buttonTextColor,
                                expression: "config.colors.buttonTextColor"
                              }
                            ],
                            staticClass:
                              "mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                            domProps: {
                              value: _vm.config.colors.buttonTextColor
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.config.colors,
                                  "buttonTextColor",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _c("verte", {
                            staticClass: "colorPicker",
                            attrs: { picker: "square", model: "hex" },
                            model: {
                              value: _vm.config.colors.buttonTextColor,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.config.colors,
                                  "buttonTextColor",
                                  $$v
                                )
                              },
                              expression: "config.colors.buttonTextColor"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block text-sm font-medium leading-5 text-gray-700",
                              attrs: { for: "city" }
                            },
                            [_vm._v("Button Icon Color")]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.config.colors.buttonIconColor,
                                expression: "config.colors.buttonIconColor"
                              }
                            ],
                            staticClass:
                              "mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                            domProps: {
                              value: _vm.config.colors.buttonIconColor
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.config.colors,
                                  "buttonIconColor",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _c("verte", {
                            staticClass: "colorPicker",
                            attrs: { picker: "square", model: "hex" },
                            model: {
                              value: _vm.config.colors.buttonIconColor,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.config.colors,
                                  "buttonIconColor",
                                  $$v
                                )
                              },
                              expression: "config.colors.buttonIconColor"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "mt-6" }, [
                    _c("div", {}, [
                      _c("div", { staticClass: "grid grid-cols-6 gap-6" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "city" }
                              },
                              [_vm._v("Button Label")]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.config.texts.contactUsLabel,
                                  expression: "config.texts.contactUsLabel"
                                }
                              ],
                              staticClass:
                                "mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                              domProps: {
                                value: _vm.config.texts.contactUsLabel
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.config.texts,
                                    "contactUsLabel",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "relative flex items-start mt-10" },
                        [
                          _c("div", { staticClass: "flex items-center h-5" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.config.addProductUrlInMessage,
                                  expression: "config.addProductUrlInMessage"
                                }
                              ],
                              staticClass:
                                "form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out",
                              attrs: {
                                id: "includeProducturl",
                                type: "checkbox"
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.config.addProductUrlInMessage
                                )
                                  ? _vm._i(
                                      _vm.config.addProductUrlInMessage,
                                      null
                                    ) > -1
                                  : _vm.config.addProductUrlInMessage
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.config.addProductUrlInMessage,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.config,
                                          "addProductUrlInMessage",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.config,
                                          "addProductUrlInMessage",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.config,
                                      "addProductUrlInMessage",
                                      $$c
                                    )
                                  }
                                }
                              }
                            })
                          ]),
                          _vm._m(0)
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "relative flex items-start mt-10" },
                        [
                          _c("div", { staticClass: " text-sm leading-5 " }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "font-medium text-blue-500 cursor-pointer",
                                attrs: { for: "sms_fallback" },
                                on: {
                                  click: function($event) {
                                    _vm.showAdvanced = !_vm.showAdvanced
                                  }
                                }
                              },
                              [
                                !_vm.showAdvanced
                                  ? _c("span", [_vm._v("Show")])
                                  : _c("span", [_vm._v("Hide")]),
                                _vm._v(" Advanced settings ")
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm.showAdvanced
                        ? _c(
                            "div",
                            { staticClass: " mt-4 grid grid-cols-6 gap-6" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block text-sm font-medium leading-5 text-gray-700",
                                      attrs: { for: "city" }
                                    },
                                    [_vm._v("Right position")]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.config.dimensions.rightPosition,
                                        expression:
                                          "config.dimensions.rightPosition"
                                      }
                                    ],
                                    staticClass:
                                      "mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                                    attrs: { type: "number" },
                                    domProps: {
                                      value: _vm.config.dimensions.rightPosition
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.config.dimensions,
                                          "rightPosition",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block text-sm font-medium leading-5 text-gray-700",
                                      attrs: { for: "city" }
                                    },
                                    [_vm._v("Left position")]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.config.dimensions.leftPosition,
                                        expression:
                                          "config.dimensions.leftPosition"
                                      }
                                    ],
                                    staticClass:
                                      "mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                                    attrs: { type: "number" },
                                    domProps: {
                                      value: _vm.config.dimensions.leftPosition
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.config.dimensions,
                                          "leftPosition",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block text-sm font-medium leading-5 text-gray-700",
                                      attrs: { for: "city" }
                                    },
                                    [_vm._v("Bottom position")]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.config.dimensions.bottomPosition,
                                        expression:
                                          "config.dimensions.bottomPosition"
                                      }
                                    ],
                                    staticClass:
                                      "mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                                    attrs: { type: "number" },
                                    domProps: {
                                      value:
                                        _vm.config.dimensions.bottomPosition
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.config.dimensions,
                                          "bottomPosition",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block text-sm font-medium leading-5 text-gray-700",
                                      attrs: { for: "city" }
                                    },
                                    [_vm._v("Button text font size")]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.config.dimensions
                                            .buttonTextFontSize,
                                        expression:
                                          "config.dimensions.buttonTextFontSize"
                                      }
                                    ],
                                    staticClass:
                                      "mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                                    attrs: { type: "number" },
                                    domProps: {
                                      value:
                                        _vm.config.dimensions.buttonTextFontSize
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.config.dimensions,
                                          "buttonTextFontSize",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block text-sm font-medium leading-5 text-gray-700",
                                      attrs: { for: "city" }
                                    },
                                    [_vm._v("Whatsapp icon size")]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.config.dimensions.iconSize,
                                        expression: "config.dimensions.iconSize"
                                      }
                                    ],
                                    staticClass:
                                      "mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                                    attrs: { type: "number" },
                                    domProps: {
                                      value: _vm.config.dimensions.iconSize
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.config.dimensions,
                                          "iconSize",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "mt-8 border-t border-gray-200 pt-5" },
                    [
                      _c("div", { staticClass: "flex justify-end" }, [
                        _c(
                          "span",
                          {
                            staticClass: "ml-3 inline-flex rounded-md shadow-sm"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "Polaris-Button Polaris-Button--primary",
                                attrs: { type: "submit" },
                                on: { click: _vm.save }
                              },
                              [_vm._m(1)]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ml-3 text-sm leading-5 " }, [
      _c(
        "label",
        {
          staticClass: "font-medium text-gray-700",
          attrs: { for: "includeProducturl" }
        },
        [_vm._v("Include product URL while customer initiates the chat ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "Polaris-Button__Content" }, [
      _c("span", { staticClass: "Polaris-Button__Text" }, [_vm._v("Save")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }